import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import s from './dre.scss';
var DRE = function (_a) {
    var environment = _a.environment, dre = _a.dre;
    var _b = useState('n/a'), appInfo = _b[0], updateAppInfo = _b[1];
    useEffect(function () {
        updateAppInfo(window['__APP_INFO__']);
    }, []);
    var url = Url.buildFromPath("dre/share?dumpid=".concat(dre === null || dre === void 0 ? void 0 : dre.dumpId, "&token=").concat(dre === null || dre === void 0 ? void 0 : dre.dumptoken), 'https://admin.deviantart.com/');
    var openWindow = function () {
        var win = window.open(url, 'DRE_Console', "left=100,top=225,width=".concat(Math.round(document.body.offsetWidth * 0.8), ",height=").concat(Math.round(screen.height * 0.7), ",toolbar = 0, scrollbars = 1, location = 0, status = 0, statusmenubar = 0, resizable = 1"));
        if (!win) {
            return alert('DRE window has been blocked as a popup');
        }
        win.focus();
    };
    var wrapEvent = function (eventCount, label) {
        if (!eventCount) {
            return "0".concat(label);
        }
        return (React.createElement("span", null,
            React.createElement("strong", null, eventCount),
            label));
    };
    return (React.createElement("div", { className: classnames(s['root'], (dre === null || dre === void 0 ? void 0 : dre.alarmEvents) && (dre === null || dre === void 0 ? void 0 : dre.alarmEvents) > 0 && s['alert']), onClick: openWindow }, dre === null || dre === void 0 ? void 0 :
        dre.hostname,
        " ", dre === null || dre === void 0 ? void 0 :
        dre.totaltime,
        "ms ",
        React.createElement("br", null),
        React.createElement("span", { className: s['alarms'] }, wrapEvent(dre === null || dre === void 0 ? void 0 : dre.alarmEvents, 'A')),
        ' ',
        wrapEvent(dre === null || dre === void 0 ? void 0 : dre.warningEvents, 'W'),
        " ",
        wrapEvent(dre === null || dre === void 0 ? void 0 : dre.noticeEvents, 'N'),
        ' ',
        (dre === null || dre === void 0 ? void 0 : dre.myEvents) && wrapEvent(dre === null || dre === void 0 ? void 0 : dre.myEvents, 'M'),
        ' ',
        (dre === null || dre === void 0 ? void 0 : dre.quickEvents) && wrapEvent(dre === null || dre === void 0 ? void 0 : dre.quickEvents, 'Q'),
        ' ',
        wrapEvent(dre === null || dre === void 0 ? void 0 : dre.infoEvents, 'T'),
        React.createElement("div", null, appInfo)));
};
DRE.displayName = 'DRE';
export default DRE;
//# sourceMappingURL=dre.js.map